<template>
  <!--
    The global boundary: the last resort for anything the per-feature boundaries
    in the layouts do not contain — a crash in a layout itself, or in a view
    rendered outside MainLayout.

    resetOnRouteChange is off here deliberately. If the shell failed to render,
    navigating is unlikely to fix it, and clearing on every route change would
    loop the user back through the same crash.

    showDetails is resolved here, in the app, rather than inside the library: Vite
    resolves import.meta.env when a package is built, so a library reading it would
    report its own build mode forever, not ours.
  -->
  <ErrorBoundary :reset-on-route-change="false" :show-details="isDev">
    <router-view />
  </ErrorBoundary>

  <!-- Outside the boundary: a caught error replaces the slot, and notifications
       should keep working while the fallback is showing. -->
  <ToastContainer />
</template>

<script setup lang="ts">
  import { ErrorBoundary, ToastContainer } from '@asabdev/asab-ui';

  const isDev = import.meta.env.DEV;
</script>
